// Утилиты для работы с городами
export const CITY_OPTIONS = [
  { label: 'Казань', value: 'Казань' },
  { label: 'Нижний Новгород', value: 'Нижний Новгород' },
  { label: 'Уфа', value: 'Уфа' },
  { label: 'Пенза', value: 'Пенза' },
  { label: 'Чебоксары', value: 'Чебоксары' },
  { label: 'Саранск', value: 'Саранск' },
  { label: 'Ижевск', value: 'Ижевск' },
  { label: 'Красноярск', value: 'Красноярск' },
  { label: 'Набережные Челны', value: 'Набережные Челны' },
  { label: 'Мастер сервис', value: 'Мастер сервис' },
  { label: 'Рязань', value: 'Рязань' },
  { label: 'Йошкар-Ола', value: 'Йошкар-Ола' },
  { label: 'Тест', value: 'Тест' },
  { label: 'Города', value: 'Города' },
  { label: 'Иваново', value: 'Иваново' },
  { label: 'Кохма', value: 'Кохма' },
  { label: 'Москва', value: 'Москва' },
  { label: 'Пушкино', value: 'Пушкино' },
];

export const getCityNameById = (cityId: number): string => {
  const cityNames: { [key: number]: string } = {
    0: 'Казань',
    14: 'Нижний Новгород',
    16: 'Уфа',
    18: 'Пенза',
    40: 'Чебоксары',
    46: 'Саранск',
    50: 'Ижевск',
    52: 'Красноярск',
    56: 'Набережные Челны',
    60: 'Мастер сервис',
    58: 'Рязань',
    34: 'Йошкар-Ола',
    64: 'Тест',
    12: 'Города',
    125: 'Иваново',
    127: 'Кохма',
    20: 'Москва',
    111: 'Пушкино',
  };
  return cityNames[cityId] || `Город ${cityId}`;
};
